import { render, staticRenderFns } from "./AuthForgotPassForm.vue?vue&type=template&id=fe80d812&scoped=true&"
import script from "./AuthForgotPassForm.vue?vue&type=script&lang=js&"
export * from "./AuthForgotPassForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthForgotPassForm.vue?vue&type=style&index=0&id=fe80d812&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe80d812",
  null
  
)

export default component.exports